import React from 'react';
import classnames from 'classnames/bind';

import styles from './ideaReturnToDateStyles';

import Icon from 'buyside/components/presentation/Icon/icon';

import { roundNumber } from 'buyside/util/formatNumber';

import TriangleUpIcon from 'SVGs/triangle_up';
import TriangleDownIcon from 'SVGs/triangle_down';

const cx = classnames.bind(styles);

const IdeaReturnToDate = ({ style, totalReturn, closedAt, showHeader = true }) => {
  let returnFigure = <figure className={styles.pendingText}>Pending...</figure>;
  if (totalReturn || totalReturn === 0) {
    totalReturn = Number(totalReturn);
    const direction = totalReturn >= 0 ? 'positive' : 'negative';
    const returnIcon = direction === 'positive' ? TriangleUpIcon : TriangleDownIcon;
    const returnClass = cx({ returnText: true, [direction]: true });
    const iconClass = cx({ returnIcon: true, [direction]: true });
    returnFigure = (
      <figure className={returnClass}>
        <Icon style={iconClass} type={returnIcon} />
        {direction === 'positive' ? '+' : ''}
        {roundNumber(totalReturn, 1)}%
      </figure>
    );
  }

  return (
    <div className={style}>
      {showHeader && (
        <h5 className={styles.returnToDateHeader}>
          {closedAt ? 'Realized Return:' : 'Return To Date:'}
        </h5>
      )}
      {returnFigure}
    </div>
  );
};

export default IdeaReturnToDate;
